import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Box from '../../../lib/appfuse-react/component/Box';
import { useStyles } from '../styles/useStyles';

/**
 * Thank you content card component
 * Displays success message and back button
 */
function ThankContent() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.contentWrapper}>
      <Box className={classes.thankCard}>
        <CheckCircleOutlineIcon className={classes.successIcon} />
        <Typography className={classes.thankTitle}>
          感謝您的填寫
        </Typography>
        <Typography className={classes.thankSubtitle}>
          Thank you for filling in
        </Typography>
        <Box
          component="button"
          className={classes.backButton}
          onClick={() => history.push('/')}
        >
          <Typography className={classes.backButtonText}>
            回到填寫頁面 Back to resume page
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ThankContent;
